import '../payout.scss';

import { Button, WarningModal } from '@basqet-dashboard/common/components';
import { PERMISSIONS } from '@basqet-dashboard/common/config';
import { useHasPermission } from '@basqet-dashboard/common/hooks';
import { SelectPayoutTransferTypeModal } from '@components';
import { PayoutWalletList } from '@components';
import { TwoFactorAuthenticationModal } from '@components/2fa/2fa';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { PayoutsHistoryTable } from '../payout-history-page';
import { PayoutActions, PayoutBenefits } from '.';

function PayoutsSummary() {
  const [selectedModal, setSelectedModal] = useState(null);
  const closeModal = () => {
    setSelectedModal(null);
  };

  const hasPermission = useHasPermission();
  const canManagePayouts = hasPermission(PERMISSIONS.PAYOUTS_MANAGE);

  const ModalToShow = modals[selectedModal];
  return (
    <>
      <div>
        {canManagePayouts && <PayoutWalletList />}
        <section className="payout">
          {canManagePayouts && <PayoutActions setSelectedModal={setSelectedModal} />}
          <PayoutBenefits />
        </section>
        <PayoutsHistoryTable
          title="All recent"
          link={{ url: '/payouts/history', position: 'top' }}
        />
      </div>
      {selectedModal && (
        <ModalToShow setSelectedModal={setSelectedModal} onModalClose={closeModal} />
      )}
    </>
  );
}

const WarnAbout2FA = ({ onModalClose, setSelectedModal }) => {
  return (
    <WarningModal
      onModalClose={onModalClose}
      header={{ name: 'Two Factor Authentication', cursive: 'Disabled' }}>
      <p className="payout__2fa-warning">
        You need to enable two factor authentication before you can transfer money out of your
        payout wallet
      </p>

      <Button onClick={() => setSelectedModal('ENABLE_TWOFA')} isFull>
        Enable Two Factor Authentication
      </Button>
    </WarningModal>
  );
};

WarnAbout2FA.propTypes = {
  onModalClose: PropTypes.func,
  setSelectedModal: PropTypes.func
};

const modals = {
  WARN_ABOUT_2FA: WarnAbout2FA,
  ENABLE_TWOFA: TwoFactorAuthenticationModal,
  PAYOUT_TRANSFER_MODAL: SelectPayoutTransferTypeModal
};
export { PayoutsSummary };
